import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { Guide } from './types';

export type DeleteGuideStepOptions = CommonRequestOptions;

export type DeleteGuideStepResult = Guide;

export async function deleteGuideStep(
   guideid: number,
   stepid: number,
   revisionid: number,
   common: DeleteGuideStepOptions = {}
): Promise<DeleteGuideStepResult> {
   return makeRequest('delete', `guides/${guideid}/steps/${stepid}`, {
      ...common,
      query: {
         revisionid,
      },
   });
}
